<template>
  <transition name="fade">
    <div
      v-if="isIdle"
      class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center z-50"
    >
      <div class="overlay fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-400 bg-opacity-25"></div>
      </div>

      <div
        class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full shadow-sm rounded border-1 border-grey-lightest"
        role="dialog"
        aria-modal="true"
      >
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div
              class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
            >
              <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900">Session Timeout</h3>
              <div class="mt-2">
                <p class="text-sm leading-5 text-gray-500">
                  Due to 15 minutes of inactivity your session has expired and you will be redirected to reauthenticate
                  your login again.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue'
import { useGeneralStore } from '@/stores/general'

/* Presentation only. The idle timer itself lives in useIdleSession(), called
   once from App.vue - keeping it here meant it only ran on the handful of
   routes this component was rendered on. */
const generalStore = useGeneralStore()

const isIdle = computed(() => generalStore.isIdle)
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
